export enum EmploymentWorkingSchedule {
FixedWeekly,
ChangeDaily,
Free,
}
